// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XRZy","colBig":"styles_colBig__2J8UR","colSmall":"styles_colSmall__3YSxN"};